import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid, Receipt, Plus, Settings } from 'lucide-react';

const tabs = [
  { key: 'dashboard', label: 'Home', icon: LayoutGrid },
  { key: 'activity', label: 'Activity', icon: Receipt },
  { key: 'charge', label: 'Charge', icon: Plus, center: true },
  { key: 'profile', label: 'Profile', icon: Settings },
];

const BottomNav = ({ active, onChange }) => (
  <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 safe-bottom">
    <div className="mx-3 mb-3 rounded-3xl border border-border/60 bg-background/85 backdrop-blur-xl shadow-lg flex items-center justify-between px-3 py-2">
      {tabs.map((t) => {
        const Icon = t.icon;
        const isActive = active === t.key;
        if (t.center) {
          return (
            <button
              key={t.key}
              data-testid={`nav-tab-${t.key}`}
              onClick={() => onChange(t.key)}
              className="relative -mt-6 w-14 h-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-xl active:scale-95 transition-transform"
              aria-label="Charge"
            >
              <Icon size={26} strokeWidth={2.75} />
            </button>
          );
        }
        return (
          <button
            key={t.key}
            data-testid={`nav-tab-${t.key}`}
            onClick={() => onChange(t.key)}
            className="flex-1 flex flex-col items-center gap-1 py-1.5 group"
          >
            <Icon size={21} strokeWidth={2.5} className={isActive ? 'text-primary' : 'text-muted-foreground group-active:scale-90 transition-transform'} />
            <span className={`text-[10px] font-bold ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>{t.label}</span>
          </button>
        );
      })}
    </div>
  </nav>
);

const MerchantShell = ({ active, onChange, children }) => (
  <div className="min-h-screen bg-background text-foreground max-w-md mx-auto relative">
    <motion.div
      key={active}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      className="pb-[110px]"
    >
      {children}
    </motion.div>
    <BottomNav active={active} onChange={onChange} />
  </div>
);

export default MerchantShell;
